<template>
<v-container class="my-8" >
    <slot></slot>
</v-container>
<!-- <div>
  <slot></slot>
</div> -->
</template>

<script>
    export default {
      name: 'PageContent',
      props:{

      },
      data () {
        return {

        }
      },
      methods: {
      },
      watch:{

      }
    }
  </script>
  <style>

  </style>
